(function() {
  "use strict";

  var CARD_SELECTOR = ".product-card[data-product-id][data-variant-id]";
  var CONTROL_SELECTOR = "[data-card-cart-control]";
  var ADD_BUTTON_SELECTOR = "[data-card-add-button]";
  var QTY_ACTION_SELECTOR = "[data-card-qty-action]";
  var QTY_VALUE_SELECTOR = "[data-card-qty-value]";
  var FORM_WRAPPER_SELECTOR = ".product-card__form";
  var refreshTimer = null;
  var refreshPromise = null;
  var cartState = null;
  var mutationObserver = null;
  var pendingUpdates = {};
  var debugRunId = "initial";

  function debugLog(payload) {
    fetch("http://127.0.0.1:7586/ingest/4b94d7ed-0ecd-42c4-be23-fb7dfb4b6c12", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Debug-Session-Id": "8c8956"
      },
      body: JSON.stringify({
        sessionId: "8c8956",
        runId: debugRunId,
        timestamp: Date.now(),
        location: payload.location,
        message: payload.message,
        hypothesisId: payload.hypothesisId,
        data: payload.data || {}
      })
    }).catch(function() {});
  }

  function toInt(value) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function parseResponseJSON(response) {
    if (!response.ok) {
      throw new Error("Cart API request failed");
    }
    return response.json();
  }

  function fetchCart() {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = fetch("/cart.js", {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    })
      .then(parseResponseJSON)
      .then(function(cart) {
        // #region agent log
        debugLog({
          location: "assets/product-card-cart-sync.js:fetchCart.then",
          message: "Fetched cart snapshot",
          hypothesisId: "H1",
          data: {
            itemCount: cart && typeof cart.item_count !== "undefined" ? cart.item_count : null,
            firstVariantId: cart && cart.items && cart.items[0] ? toInt(cart.items[0].variant_id) : 0
          }
        });
        // #endregion
        applyCartState(cart);
        return cart;
      })
      .catch(function(error) {
        console.error("Cart sync failed", error);
        return null;
      })
      .finally(function() {
        refreshPromise = null;
      });

    return refreshPromise;
  }

  function scheduleCartRefresh(delay) {
    if (refreshTimer) {
      window.clearTimeout(refreshTimer);
    }
    refreshTimer = window.setTimeout(function() {
      refreshTimer = null;
      // #region agent log
      debugLog({
        location: "assets/product-card-cart-sync.js:scheduleCartRefresh.timeout",
        message: "Scheduled cart refresh fired",
        hypothesisId: "H1",
        data: {
          delay: delay || 400
        }
      });
      // #endregion
      fetchCart();
    }, delay || 400);
  }

  function buildCartMaps(cart) {
    var variantQtyMap = {};
    var productQtyMap = {};
    var lineByVariant = {};

    (cart.items || []).forEach(function(item, index) {
      var variantId = toInt(item.variant_id);
      var productId = toInt(item.product_id);
      var quantity = toInt(item.quantity);

      variantQtyMap[variantId] = (variantQtyMap[variantId] || 0) + quantity;
      productQtyMap[productId] = (productQtyMap[productId] || 0) + quantity;
      lineByVariant[variantId] = index + 1;
    });

    return {
      variantQtyMap: variantQtyMap,
      productQtyMap: productQtyMap,
      lineByVariant: lineByVariant
    };
  }

  function applyCartState(cart) {
    cartState = cart || { items: [] };
    var maps = buildCartMaps(cartState);

    document.querySelectorAll(CONTROL_SELECTOR).forEach(function(control) {
      var variantId = toInt(control.getAttribute("data-variant-id"));
      var productId = toInt(control.getAttribute("data-product-id"));
      var formWrapper = control.closest(FORM_WRAPPER_SELECTOR);
      var card = control.closest(".product-card");
      var qty = maps.variantQtyMap[variantId] || 0;

      if (qty === 0 && productId && maps.productQtyMap[productId]) {
        qty = maps.productQtyMap[productId];
      }

      // #region agent log
      debugLog({
        location: "assets/product-card-cart-sync.js:applyCartState.loop",
        message: "Applying qty to control",
        hypothesisId: "H3",
        data: {
          variantId: variantId,
          productId: productId,
          appliedQty: qty
        }
      });
      // #endregion

      control.querySelector(QTY_VALUE_SELECTOR).textContent = qty;
      control.setAttribute("data-current-qty", qty);

      if (formWrapper) {
        if (qty > 0) {
          formWrapper.classList.add("is-in-cart");
          if (card) {
            card.classList.add("in-cart");
          }
        } else {
          formWrapper.classList.remove("is-in-cart");
          if (card) {
            card.classList.remove("in-cart");
          }
        }
      }
    });
  }

  function setOptimisticQuantity(variantId, nextQty) {
    document.querySelectorAll(CONTROL_SELECTOR + '[data-variant-id="' + variantId + '"]').forEach(function(control) {
      // #region agent log
      debugLog({
        location: "assets/product-card-cart-sync.js:setOptimisticQuantity",
        message: "Applied optimistic qty",
        hypothesisId: "H1",
        data: {
          variantId: variantId,
          nextQty: nextQty
        }
      });
      // #endregion
      var formWrapper = control.closest(FORM_WRAPPER_SELECTOR);
      var card = control.closest(".product-card");
      control.querySelector(QTY_VALUE_SELECTOR).textContent = nextQty;
      control.setAttribute("data-current-qty", nextQty);
      if (formWrapper) {
        if (nextQty > 0) {
          formWrapper.classList.add("is-in-cart");
          if (card) {
            card.classList.add("in-cart");
          }
        } else {
          formWrapper.classList.remove("is-in-cart");
          if (card) {
            card.classList.remove("in-cart");
          }
        }
      }
    });
  }

  function openCartDrawerIfAvailable() {
    if (window.wpbingo && window.wpbingo.settings && window.wpbingo.settings.cartType === "drawer") {
      document.body.classList.add("drawer--open");
    }
  }

  function refreshThemeCartUI() {
    if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
      window.ajaxCart.load();
    }
  }

  function addVariantToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    }).then(parseResponseJSON).then(function(response) {
      // #region agent log
      debugLog({
        location: "assets/product-card-cart-sync.js:addVariantToCart.then",
        message: "cart/add.js response received",
        hypothesisId: "H4",
        data: {
          variantId: variantId,
          quantity: quantity,
          responseVariantId: response ? toInt(response.variant_id) : 0
        }
      });
      // #endregion
      return response;
    });
  }

  function changeLineQuantity(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    }).then(parseResponseJSON);
  }

  function updateVariantQuantity(variantId, nextQty) {
    if (pendingUpdates[variantId]) {
      return;
    }

    pendingUpdates[variantId] = true;
    fetchCart()
      .then(function(cart) {
        var maps = buildCartMaps(cart || { items: [] });
        var currentQty = maps.variantQtyMap[variantId] || 0;
        var safeQty = Math.max(0, nextQty);

        setOptimisticQuantity(variantId, safeQty);

        if (currentQty === 0 && safeQty > 0) {
          return addVariantToCart(variantId, safeQty).then(function() {
           // trigger theme cart update properly
if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
  window.ajaxCart.load();
}

// optional: trigger global event (some themes listen to this)
document.dispatchEvent(new CustomEvent("cart:refresh"));
            return fetchCart();
          });
        }

        var line = maps.lineByVariant[variantId];
        if (!line) {
          return fetchCart();
        }

        return changeLineQuantity(line, safeQty).then(function(cartResponse) {
          applyCartState(cartResponse);
          refreshThemeCartUI();
          return fetchCart();
        });
      })
      .finally(function() {
        pendingUpdates[variantId] = false;
      });
  }

  function getVariantIdFromForm(form) {
    var input = form.querySelector('input[name="id"]');
    return input ? toInt(input.value) : 0;
  }

  function enhanceCardForms(scope) {
    var root = scope || document;
    var cardCount = 0;
    var taggedButtonCount = 0;

    root.querySelectorAll(CARD_SELECTOR).forEach(function(card) {
      cardCount += 1;
      var productId = toInt(card.getAttribute("data-product-id"));
      var currentVariantId = toInt(card.getAttribute("data-variant-id"));

      card.querySelectorAll("form.form-addtocart").forEach(function(form) {
        var submitButton = form.querySelector(".js-btn-addtocart");
        if (!submitButton) {
          return;
        }

        var formWrapper = form.closest(FORM_WRAPPER_SELECTOR);
        if (!formWrapper) {
          return;
        }

        var variantId = getVariantIdFromForm(form) || currentVariantId;
        if (!variantId || !productId) {
          return;
        }

        card.setAttribute("data-variant-id", variantId);
        submitButton.classList.add("add-to-cart-btn");
        submitButton.setAttribute("data-card-add-button", "true");
        submitButton.setAttribute("data-variant-id", variantId);
        taggedButtonCount += 1;

        var existingControl = formWrapper.querySelector(CONTROL_SELECTOR);
        if (existingControl) {
          existingControl.setAttribute("data-variant-id", variantId);
          existingControl.setAttribute("data-product-id", productId);
          return;
        }

        // var control = document.createElement("div");
        // control.className = "card-qty-selector qty-box";
        // control.setAttribute("data-card-cart-control", "true");
        // control.setAttribute("data-product-id", productId);
        // control.setAttribute("data-variant-id", variantId);
        // control.setAttribute("data-current-qty", "0");
        // control.innerHTML = '' +
        //   '<button type="button" class="card-qty-selector__btn" data-card-qty-action="minus" aria-label="Decrease quantity">-</button>' +
        //   '<span class="card-qty-selector__value" data-card-qty-value>0</span>' +
        //   '<button type="button" class="card-qty-selector__btn" data-card-qty-action="plus" aria-label="Increase quantity">+</button>';

        // formWrapper.appendChild(control);
      });
    });

    // #region agent log
    debugLog({
      location: "assets/product-card-cart-sync.js:enhanceCardForms",
      message: "Card enhancement pass complete",
      hypothesisId: "H2",
      data: {
        cardCount: cardCount,
        taggedButtonCount: taggedButtonCount,
        isDocumentRoot: root === document
      }
    });
    // #endregion
  }

  function syncVariantReferences() {
    document.querySelectorAll(CARD_SELECTOR).forEach(function(card) {
      var form = card.querySelector("form.form-addtocart");
      if (!form) {
        return;
      }

      var variantId = getVariantIdFromForm(form);
      if (!variantId) {
        return;
      }

      card.setAttribute("data-variant-id", variantId);

      var submitButton = form.querySelector(ADD_BUTTON_SELECTOR);
      if (submitButton) {
        submitButton.setAttribute("data-variant-id", variantId);
      }

      var control = form.closest(FORM_WRAPPER_SELECTOR) ? form.closest(FORM_WRAPPER_SELECTOR).querySelector(CONTROL_SELECTOR) : null;
      if (control) {
        control.setAttribute("data-variant-id", variantId);
      }
    });
  }

  document.addEventListener("click", function(event) {
    var addButton = event.target.closest(ADD_BUTTON_SELECTOR);
    if (addButton) {
  event.preventDefault(); // VERY IMPORTANT

  var sourceForm = addButton.closest("form.form-addtocart");
  var variantId = sourceForm ? getVariantIdFromForm(sourceForm) : toInt(addButton.getAttribute("data-variant-id"));

  if (!variantId) return;

  var control = addButton.closest(FORM_WRAPPER_SELECTOR);
  var currentQty = 0;

  if (control) {
    var valueNode = control.querySelector(QTY_VALUE_SELECTOR);
    currentQty = valueNode ? toInt(valueNode.textContent) : 0;
  }

  var nextQty = currentQty + 1;

  // ✅ STEP 1: Instant UI update
  setOptimisticQuantity(variantId, nextQty);

  // ✅ STEP 2: REAL API call immediately
  // addVariantToCart(variantId, 1)
  //   .then(function () {
  //     // openCartDrawerIfAvailable();
  //     refreshThemeCartUI();

  //     // ✅ STEP 3: Sync AFTER real response
  //     return fetchCart();
  //   })
  //   .catch(function () {
  //     // ❌ rollback if failed
  //     setOptimisticQuantity(variantId, currentQty);
  //   });

  var qtyInput = sourceForm.querySelector('.js-qty-number');
var selectedQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

addVariantToCart(variantId, selectedQty)
  .then(function () {

    // Refresh cart drawer
    refreshThemeCartUI();

    // Open cart drawer
    openCartDrawerIfAvailable();

    // Reset quantity selector
    if (qtyInput) {
      qtyInput.value = 1;
    }

    // Sync card quantities
    return fetchCart();
  })

  return;
}

    var actionButton = event.target.closest(QTY_ACTION_SELECTOR);
    if (!actionButton) {
      return;
    }

    event.preventDefault();
    var control = actionButton.closest(CONTROL_SELECTOR);
    if (!control) {
      return;
    }

    var variantId = toInt(control.getAttribute("data-variant-id"));
    var currentQty = toInt(control.getAttribute("data-current-qty"));
    var action = actionButton.getAttribute("data-card-qty-action");
    var nextQty = action === "plus" ? currentQty + 1 : currentQty - 1;

    updateVariantQuantity(variantId, nextQty);
  });

  document.addEventListener("shopify:section:load", function(event) {
    enhanceCardForms(event.target);
    syncVariantReferences();
    if (cartState) {
      applyCartState(cartState);
    } else {
      fetchCart();
    }
  });

  function initMutationObserver() {
    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver(function(mutations) {
      var shouldRefresh = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 && (node.matches && node.matches(CARD_SELECTOR) || (node.querySelector && node.querySelector(CARD_SELECTOR)));
        });
      });

      if (shouldRefresh) {
        // #region agent log
        debugLog({
          location: "assets/product-card-cart-sync.js:mutationObserver",
          message: "Mutation observer triggered refresh",
          hypothesisId: "H5",
          data: {
            mutationCount: mutations.length
          }
        });
        // #endregion
        enhanceCardForms(document);
        syncVariantReferences();
        if (cartState) {
          applyCartState(cartState);
        } else {
          fetchCart();
        }
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    // #region agent log
    debugLog({
      location: "assets/product-card-cart-sync.js:init",
      message: "Cart sync init executed",
      hypothesisId: "H0",
      data: {
        readyState: document.readyState
      }
    });
    // #endregion
    enhanceCardForms(document);
    syncVariantReferences();
    fetchCart();
    initMutationObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


document.addEventListener('click', function(e) {
  if (e.target.closest('.js-drawer-close')) {
    document.body.classList.remove('drawer--open');
  }
});